export class BaseComponent {}
